<template>
  <div class="flex flex-col mb-[32px]">
      <div class="flex items-center gap-[8px] mb-[4px]">
        <IconArrowLeft v-if="withBackBtn" class="cursor-pointer" @click="$emit('on-back')" />
        <span class="text-[#212529] text-[20px] font-[500] leading-[120%]">{{ title }}</span>
      </div>

      <div class="text-[#6C757D] text-[16px] font-[400] leading-[150%]">{{ subtitle }}</div>
    </div>
</template>

<script>
import IconArrowLeft from '@/assets/images/icon-left.svg';

export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    withBackBtn: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    IconArrowLeft,
  }
}
</script>
